// TODO: 外部モジュールへの依存を消したい
import { useBrandAccountSurveyGroupsQueryData } from '~/hooks/useBrandAccountSurveyGroupsQuery'
import { useCommonQueryCurrentBrandAccount } from '~/hooks/useCommonQuery'

export const useCurrentBrandAccountSurveyGroupsQueryData = () => {
  const currentBrandAccount = useCommonQueryCurrentBrandAccount()

  return useBrandAccountSurveyGroupsQueryData(currentBrandAccount?.id)
}
